// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Review-Home-ImportReferencesSummary-components-ActivityDetailBox-ActivityDetailBox-module__detail";
var _2 = "webpack-containers-Review-Home-ImportReferencesSummary-components-ActivityDetailBox-ActivityDetailBox-module__explanation";
export { _1 as "detail", _2 as "explanation" }
